<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h5 class="mb-0 text-gray-800">
              {{ $t("Gráficos de Acessos") }}
            </h5>
          </div>
          <div style="min-width: 480px">
            <template v-if="tabAtiva == 'Por Período'">
              <div class="row">
                <form-select
                  grid="6"
                  label="Ano"
                  :itens="years"
                  v-model="filtroYear"
                  @change="getAnalytics()"
                />

                <form-select
                  grid="6"
                  label="Mês"
                  :itens="months"
                  v-model="filtroMonth"
                  placeholder="Selecione um mês"
                  @change="getAnalytics()"
                />
              </div>
            </template>
            <template v-else>
              <b-button-group class="float-right">
                <b-button
                  variant="outline-dark"
                  :class="viewFilterReport === true ? 'active' : ''"
                  @click="viewFilters"
                >
                  <i class="fas fa-filter"></i>
                  {{ $t("Filtros") }}
                </b-button>
              </b-button-group>
            </template>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="col-12">
          <p>
            Período de pesquisa selecionado:
            <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
            <b-link
              href="#"
              @click.prevent="void 0"
              class="mb-2"
              variant="info"
              v-b-popover.hover.top="
                'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
              "
            >
              <i class="fas fa-info-circle"></i>
            </b-link>
          </p>
        </div>
        <div class="col-12 no-print" v-if="viewFilterReport">
          <!-- Filtros -->
          <form @submit.prevent="getAnalytics" ref="addItem">
            <div class="row">
              <form-calendar
                v-model="data_inicio"
                grid="6"
                label="Data Inicial"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_fim"
                grid="6"
                label="Data final"
                :required="verificaDataInicial"
                :min-date="data_inicio"
                :max-date="dataNow"
              />
            </div>
            <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default"
                  @click.prevent="limparFiltros(), (viewFilterReport = false)"
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-secondary"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>

                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Gerar Gráfico") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="col-12" id="boxPrint">
        <b-tabs content-class="mt-3">
          <b-tab title="Por Período" @click.prevent="changeTab('Por Período')">
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Período'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />

                <span v-if="report.acessos.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <area-graph
                  v-else
                  :loading="loading"
                  :data="report.acessos"
                  :titulo="'Acessos Por Período'"
                  :range="range"
                  sizearea="300px"
                  sizecard="375px"
                  tipo="acessos"
                />
                <div class="col-md-12">
                  <p class="text-muted small pb-1 mb-1">
                    Total de
                    <b>({{ report.total_acessos }})
                    </b>
                    {{ tabAtiva }}
                  </p>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            title="Por Técnicos"
            @click.prevent="changeTab('Por Técnicos')"
          >
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Técnicos'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />
                <span v-if="report.por_tecnicos.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <bar-chart
                  v-else
                  :data="report.por_tecnicos"
                  :style="sizeTecnicos"
                ></bar-chart>
              </div>
            </div>
          </b-tab>
          <b-tab
            title="Por Unidades"
            @click.prevent="changeTab('Por Unidades')"
          >
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Unidades'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />

                <span v-if="report.por_unidades.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <bar-chart
                  v-else
                  :data="report.por_unidades"
                  :style="sizeUnidades"
                ></bar-chart>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "AcessosGraficos",
  data() {
    return {
      loading: true,
      range: "yearly",
      report: {
        acessos: [],
        por_tecnicos: [],
        por_unidades: [],
        total_acessos: 0,
        datas: {
          start: "",
          end: "",
        },
      },
      years: [],
      months: [],
      filtros: {},
      filtroYear: moment().format("YYYY"),
      filtroMonth: null,
      sizeTecnicos: "min-height: 500px",
      sizeUnidades: "min-height: 500px",
      tabAtiva: "Por Período",
      dataNow: moment().format("YYYY/MM/DD"),
    };
  },
  mounted() {
    this.getAnalytics();
  },
  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Por Período";
      }
      this.getAnalytics();
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      if (this.filtroMonth) {
        this.range = "monthly";
      } else {
        this.range = "yearly";
      }
      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/acessos/graficos", {
          params: {
            range: this.range,
            filtros: this.filtros,
            filtroYear: this.filtroYear,
            filtroMonth: this.filtroMonth,
            ...tab,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data;
          this.years = response.data.data.years;
          this.months = response.data.data.months;
          if (this.report.por_tecnicos) {
            this.sizeTecnicos =
              Object.keys(this.report.por_tecnicos).length * 20;
            this.sizeTecnicos = "min-height: " + this.sizeTecnicos + "px";
          }
          if (this.report.por_unidades) {
            this.sizeUnidades =
              Object.keys(this.report.por_unidades).length * 20;
            this.sizeUnidades = "min-height: " + this.sizeUnidades + "px";
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    limparFiltros() {
      this.filtros.data_inicial = null;
      this.filtros.data_final = null;
      this.data_inicio = null;
      this.data_fim = null;
      this.getAnalytics();
    },
  },
};
</script>

<style scoped>
.btn-group .btn {
  padding: 6px 14px !important;
  margin-right: 0px;
}

::-webkit-scrollbar-track {
  background-color: #f4f4f4;
}
::-webkit-scrollbar {
  width: 5px;
  background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 25em;
}
</style>

